import OncolensToast from '@/components/OncolensToast';
import { yupResolver } from '@hookform/resolvers/yup';
import ButtonWithLoading from '@oncolens/oncolens-ui/lib/components/FormControls/ButtonWithLoading';
import Checkbox from '@oncolens/oncolens-ui/lib/components/FormControls/Checkbox';
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useGetUser } from '../api/getUser';
import { useUpdateUserOmitFromReporting } from '../api/updateUserOmitFromReporting';
import { UserSettingsDto } from '../types/index';

const userSettingsSchema = yup.object().shape({
  omitFromReporting: yup.boolean(),
});

interface SettingsFormProps {
  userId: string | undefined;
}

function UserSettingsForm({ userId }: SettingsFormProps) {
  const { data: user } = useGetUser(userId);
  const {
    control,
    formState: { errors },
    setValue,
    handleSubmit,
  } = useForm<UserSettingsDto>({
    resolver: yupResolver(userSettingsSchema),
  });

  const updateUserSettingOmitForReporting = useUpdateUserOmitFromReporting(user?.data?.id);
  const onSubmit = (data: UserSettingsDto) => {
    updateUserSettingOmitForReporting.mutate(data?.omitFromReporting);
  };

  useEffect(() => {
    if (updateUserSettingOmitForReporting.isSuccess) OncolensToast.success('Settings saved');
    if (updateUserSettingOmitForReporting.isError) OncolensToast.error('Error occurred.');
  }, [updateUserSettingOmitForReporting.isError, updateUserSettingOmitForReporting.isSuccess]);

  useEffect(() => {
    setValue('omitFromReporting', user?.data?.omitFromReporting ?? false);
  }, [setValue, user]);

  return (
    <div className="col-span-full">
      {/* <h3 className="text-lg font-medium text-blue-gray-900">Settings</h3> */}

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6 divide-y divide-y-blue-gray-200">
        <div className="sm:flex sm:justify-end sm:col-span-6">
          <div className="block pt-2 space-y-2 sm:pt-0 sm:space-y-0 sm:justify-end sm:space-x-4 sm:flex">
            <ButtonWithLoading
              disabled={updateUserSettingOmitForReporting.isLoading}
              loading={updateUserSettingOmitForReporting.isLoading}
              className="w-full sm:w-24"
              buttonColor="blue"
              type="submit">
              Save
            </ButtonWithLoading>
          </div>
        </div>

        <div className="pt-4">
          <div className="sm:col-span-6">
            <Controller
              name="omitFromReporting"
              control={control}
              render={({ field }) => (
                <div className="col-span-7">
                  <Checkbox
                    id="omitFromReporting"
                    htmlName="omitFromReporting"
                    label="Omit from Reporting"
                    value={field.value}
                    onClick={field.onChange}
                  />
                  {errors?.omitFromReporting?.message ? (
                    <p className="mt-2 text-sm text-red-600">
                      {errors?.omitFromReporting?.message}
                    </p>
                  ) : null}
                </div>
              )}
            />
          </div>
          {/* <Switch.Group
              as="div"
              className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-b sm:border-gray-200"
            >
              <Switch.Label as="dt" className="text-sm font-medium text-gray-500" passive>
                Auto-update applicant data
              </Switch.Label>
              <dd className="flex mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                <Switch
                  checked={autoUpdateApplicantDataEnabled}
                  onChange={setAutoUpdateApplicantDataEnabled}
                  className={classNames(
                    autoUpdateApplicantDataEnabled ? 'bg-oncolensOrange-600' : 'bg-gray-200',
                    'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-oncolensOrange-500 sm:ml-auto'
                  )}
                >
                  <span
                    aria-hidden="true"
                    className={classNames(
                      autoUpdateApplicantDataEnabled ? 'translate-x-5' : 'translate-x-0',
                      'inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
                    )}
                  />
                </Switch>
              </dd>
            </Switch.Group> */}
        </div>
      </form>
    </div>
  );
}

export default UserSettingsForm;
